import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="bg-[#1E2B3C] text-[#FAF9F6] mt-20" data-testid="site-footer">
      {/* Columns */}
      <div className="px-6 md:px-12 lg:px-24 py-20 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-baseline gap-1">
            <span className="font-serif-display text-3xl">
              Maison <span className="italic text-[#D99A29]">Marigold</span>
            </span>
          </div>
          <p className="mt-4 text-white/60 text-sm leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <p className="overline text-white/70">{t.footer.shop}</p>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/spices" className="link-underline" data-testid="footer-cat-spices">{t.categories.spices}</Link></li>
            <li><Link to="/saffron" className="link-underline text-[#D99A29]" data-testid="footer-cat-saffron">{t.categories.saffron}</Link></li>
            <li><Link to="/textiles" className="link-underline" data-testid="footer-cat-textiles">{t.categories.textiles}</Link></li>
            <li><Link to="/deco" className="link-underline" data-testid="footer-cat-deco">{t.categories.deco}</Link></li>
            <li><Link to="/oils" className="link-underline" data-testid="footer-cat-oils">{t.categories.oils}</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline text-white/70">{t.footer.house}</p>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/story" className="link-underline" data-testid="footer-story">{t.footer.story}</Link></li>
            <li><Link to="/artisans" className="link-underline" data-testid="footer-artisans">{t.footer.artisans}</Link></li>
            <li><Link to="/contact" className="link-underline" data-testid="footer-contact">{t.footer.contact}</Link></li>
          </ul>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-24 py-6 border-t border-white/10 flex flex-col md:flex-row gap-2 md:justify-between text-xs text-white/50">
        <p>© 2026 Maison Marigold · Paris. {t.footer.rights}</p>
        <p>Vasudhaiva Kutumbakam — वसुधैव कुटुम्बकम्</p>
      </div>
    </footer>
  );
};

export default Footer;
